import React from "react";
import { Link } from "react-router-dom";
import { nav, company } from "../mock";
import { locations } from "../locationData";
import { posts } from "../blogData";
import Logo from "./Logo";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const primaryServices = [
    { label: "Taktvätt i Stockholm", to: "/taktvatt-stockholm" },
    { label: "Takmålning i Stockholm", to: "/takmalning-stockholm" },
    { label: "Takbehandling i Stockholm", to: "/takbehandling-stockholm" },
    { label: "Solcellstvätt i Stockholm", to: "/solcellstvatt-stockholm" },
    { label: "Takunderhåll för BRF", to: "/brf" },
  ];
  return (
    <footer className="bg-slate-950 text-white">
      <div className="mx-auto max-w-7xl px-6 py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo variant="light" />
          <p className="mt-4 text-sm text-white/60 max-w-xs">
            Högpresterande taktvätt, takmålning och solcellstvätt – utfört av egna
            certifierade proffs i Stockholms län & Uppsala.
          </p>
        </div>
        <div>
          <h4 className="font-bold mb-4">Tjänster</h4>
          <ul className="space-y-2 text-sm text-white/60">
            {primaryServices.map((service) => <li key={service.to}><Link to={service.to} className="hover:text-white transition-colors" data-testid={`footer-service-${service.to.slice(1)}`}>{service.label}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-4">Navigering</h4>
          <ul className="space-y-2 text-sm text-white/60">
            {nav.map((n) => <li key={n.href}><a href={n.href.startsWith("#") ? `/${n.href}` : n.href} className="hover:text-white transition-colors" data-testid={`footer-nav-${n.label.toLowerCase().replace(/[^a-zåäö0-9]+/g, "-")}`}>{n.label}</a></li>)}
            <li><Link to="/om-oss" className="hover:text-white transition-colors" data-testid="footer-about-hpr-link">Om HPR</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-4">Kontakt</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li><a href={company.phoneHref} className="flex items-center gap-2 hover:text-white"><Phone className="w-4 h-4" /> {company.phone}</a></li>
            <li><a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-white"><Mail className="w-4 h-4" /> {company.email}</a></li>
            <li><a href={`mailto:${company.billingEmail}`} className="flex items-center gap-2 hover:text-white"><Mail className="w-4 h-4" /> {company.billingEmail} <span className="text-white/40">(faktura)</span></a></li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {company.city}</li>
          </ul>
        </div>
      </div>
      {/* Local SEO area links */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-8">
          <h4 className="font-bold mb-4 text-sm uppercase tracking-wide text-white/70">Taktvätt & takmålning där du bor</h4>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/60">
            {locations.map((l) => (
              <Link key={l.slug} to={`/${l.slug}`} className="hover:text-[#38BDF8] transition-colors" data-testid={`footer-loc-${l.slug}`}>
                {l.service} {l.city}
              </Link>
            ))}
          </div>
          <h4 className="font-bold mb-4 mt-8 text-sm uppercase tracking-wide text-white/70">Guider</h4>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/60">
            <Link to="/guider" className="hover:text-[#38BDF8] transition-colors" data-testid="footer-guider">Alla guider</Link>
            {posts.map((p) => (
              <Link key={p.slug} to={`/guider/${p.slug}`} className="hover:text-[#38BDF8] transition-colors" data-testid={`footer-post-${p.slug}`}>
                {p.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <p>© {new Date().getFullYear()} <span className="font-brand font-bold text-white/70">HPR</span> – High Performance Roofing i Sverige AB. Alla rättigheter förbehållna.</p>
          <div className="flex gap-6"><a href="#" className="hover:text-white">Integritetspolicy</a><a href="#" className="hover:text-white">Cookies</a></div>
        </div>
      </div>
    </footer>
  );
}
